module.exports = __webpack_public_path__ + "static/media/aroma-theme.68744aec.wav";